import PropTypes from 'prop-types';
import React, { useState, useEffect, useMemo } from "react";

import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { toast } from "react-toastify";

//import components
import Breadcrumbs from '../../components/Common/Breadcrumb';
import TableContainer from '../../components/Common/DataTableContainer';

import { useDispatch, useSelector } from "react-redux";
import { fetchVehiclesCategoriesData } from "../../store/vehicles-categories/actions";

const VehiclesCategories = props => {
  const dispatch = useDispatch();
    const navigate = useNavigate();

  const { data, loading, error } = useSelector(state => state.vehiclesCategories);

  useEffect(() => {
    dispatch(fetchVehiclesCategoriesData());
  }, [dispatch]);

  const handleDelete = async (id) => {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, delete it!"
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const token = localStorage.getItem("authToken");
            const response = await fetch(
              `${process.env.REACT_APP_WEB_APP_URL}/api/web/vehicles-categories/delete/${id}`,
              {
                method: "POST",
                headers: {
                  Accept: "application/json",
                  Authorization: `Bearer ${token}`,
                },
              }
            );
  
            const result = await response.json();
  
            if (response.status === 200) {
              toast.success('Vehicle Category has been deleted.', { autoClose: 3000 });
              dispatch(fetchVehiclesCategoriesData());
            } else {
              toast.error(result?.message || 'Failed to delete', { autoClose: 3000 });
            }
          } catch (err) {
            console.error(err);
            toast.error("Failed to delete vehicle category", { autoClose: 3000 });
          }
        }
      });
    };
  
    const handleRestore = async (id) => {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#f8b425",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, restore it!"
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const token = localStorage.getItem("authToken");
            const response = await fetch(
              `${process.env.REACT_APP_WEB_APP_URL}/api/web/vehicles-categories/restore/${id}`,
              {
                method: "POST",
                headers: {
                  Accept: "application/json",
                  Authorization: `Bearer ${token}`,
                },
              }
            );
  
            const result = await response.json();
  
            if (response.status === 200) {
              toast.success('Vehicle Category has been restored.', { autoClose: 3000 });
              dispatch(fetchVehiclesCategoriesData());
            } else {
              toast.error(result?.message || 'Failed to restored', { autoClose: 3000 });
            }
          } catch (err) {
            console.error(err);
            toast.error("Failed to restored vehicle category", { autoClose: 3000 });
          }
        }
      });
    };

  const columns = useMemo(
    () => [
      {
        header: "Image",
        accessorKey: "image",
        enableColumnFilter: false,
        cell: ({ row }) => (
          <img
            src={row.original.icon || "assets/images/no-image.png"}
            alt="Profile"
            style={{ width: 40, height: 40, borderRadius: "50%" }}
          />
        )
      },
      {
        header: 'Name',
        accessorKey: 'name',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Is Enable?',
        accessorKey: 'is_enable',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Total Vehicles',
        accessorKey: 'totalVehicles',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Action',
        id: 'action',
        cell: ({ row }) => {
          const vehicleId = row.original?.id;
          const is_deleted = row.original?.is_deleted;
          return (
            <div className="d-flex gap-2">
              <button
                className="btn btn-sm btn-success"
                onClick={() => navigate(`/vehicles-categories/edit/${vehicleId}`)}
              >
                <i className="mdi mdi-pencil"></i> Edit
              </button>
              {is_deleted == 1 ? (
                <button
                  className="btn btn-sm btn-warning"
                  onClick={() => handleRestore(vehicleId)}
                >
                  <i className="mdi mdi-restore"></i> Restore
                </button>
              ) : (
                <button
                  className="btn btn-sm btn-danger"
                  onClick={() => handleDelete(vehicleId)}
                >
                  <i className="mdi mdi-delete"></i> Delete
                </button>
              )}
            </div>
          );
        }
      }
    ],
    []
  );

  const totalRecords = data?.data?.length ?? 0;

  const transformedData = useMemo(() => {
    return data?.data?.map(item => {
      return {
        image: item.icon || "assets/images/no-image.png",
        name: item.displayname || "N/A",
        is_enable: item.isenable == 1 ? 'YES' : 'NO' || "N/A",
        totalVehicles: item.total_vehicles || 0,
        ...item
      };
    });
  }, [data]);

  document.title = "Vehicles Categories | Moeen";
  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs title="Home" breadcrumbItem="Vehicles Categories" />
        <div className="float-end d-none d-md-block">
          <Link to="/vehicles-categories/create"
            color="primary"
            className="btn btn-primary text-white waves-effect waves-light"
          >
            Add Vehicle Category
          </Link>
        </div>
        {loading ? (
          <Skeleton count={10} height={40} />
        ) : (
          <TableContainer
            columns={columns}
            data={transformedData || []}
            isGlobalFilter={true}
            isPagination={true}
            SearchPlaceholder={`Looking for something? ${totalRecords} results loaded.`}
            pagination="pagination"
            paginationWrapper='dataTables_paginate paging_simple_numbers'
            tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
          />
        )}
      </div>
    </div>
  );
};

VehiclesCategories.propTypes = {
  t: PropTypes.any
};

export default VehiclesCategories;